import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import SharePrice from '../../../components/Home/SharePrice';
import LatestNews from '../../../components/Home/LatestNews';

import './style.scss';

export default class HomeIE extends Component {
    constructor() {
        super();
        this.state = {
            data: require('./data.json'),
        };
    }
    render() {
        const { data } = this.state;
        return (
            <Fragment>
                <ul>
                    <li className="shareprice">
                        <h1>Share Price</h1>
                        <SharePrice />
                        <h1>Latest News</h1>
                        <LatestNews />
                    </li>
                    <li className="keyfacts">
                        <h1>Key Facts</h1>
                        <ul className="keyfacts-home">
                            <li className="left">
                                <span>
                                    Revenue
                                    <span className="right">
                                        {data.keyfacts.revenue[0].percent}%
                                    </span>
                                </span>
                                <img
                                    alt="Revenue"
                                    className="iefix"
                                    src="https://files.jdplc.com/images/iefix/revenue.png"
                                />
                            </li>
                            <li className="right">
                                <span>
                                    Profit before tax
                                    <span className="right">
                                        {data.keyfacts.profit[0].percent}%
                                    </span>
                                </span>
                                <img
                                    alt="Profit before tax"
                                    className="iefix"
                                    src="https://files.jdplc.com/images/iefix/profit_before_tax.png"
                                />
                            </li>
                            <li className="left employees">
                                <p>{data.keyfacts.employees}</p>
                                <i></i>
                                <span>Employees</span>
                                <Link to="/key-facts">More key facts</Link>
                            </li>
                            <li className="right territories">
                                <i></i>
                                <p>
                                    {data.keyfacts.territories}
                                    <span>Territories</span>
                                </p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </Fragment>
        );
    }
}
